import ReportBase from 'app/models/report_base';

export default ReportBase.extend({
  reportType: 'payment_log',
});



// WEBPACK FOOTER //
// ./app/models/payment_log_report.js